import { hashCodeWithVersion } from '@virtuslab/nfs-shared/src/services/string';

export const contractParamName = 'contractIndex';

export const localStorageKeys = {
  lastSelectedContractId: hashCodeWithVersion('lastSelectedContractId', 1),
  timeReportPreferences: hashCodeWithVersion('timeReportPreferences', 1),
  bookingExpandedGroups: hashCodeWithVersion('bookingExpandedGroups', 1),
};

export const maxPrefferedProjectDayOffset = 31;

export const trGuideURL = 'https://coda.io/d/Company-Guide_dLnC4frK169/Time-Report-NFS_suy8E#_lujU-';

export const nfsFeedbackSlackURL = 'https://virtuslab.slack.com/app_redirect?channel=C048BEF4QJF';

export const preventAbsencesBackNavigationAfterNMonths = 12;

export const warningThreshold = { months: 3 } as const;

// Kraków, Szlak 49
export const mainOfficeId = 'a1fc564a-7e98-4847-aec2-227930b04c01';
